<template>
  <div ref="suggestions" class="suggestion-list">
    <template v-if="hasResults">
      <div
        v-for="(category, catIndex) in items"
        :key="`suggestion-list-${category.type}`"
        class="suggestion-list-category"
      >
        <template v-if="category.items.length">
          <div class="header">{{ category.label }}</div>
          <div
            v-for="(mention, mentionIndex) in category.items"
            :id="`suggestion-list__item__${mention.id}`"
            :key="mention.id"
            :class="[
              'suggestion-list__item',
              `suggestion-${category.type}`,
              {
                'is-selected':
                  selectedMentionTypeIndex === catIndex &&
                  selectedMentionIndex === mentionIndex,
              },
            ]"
            :style="itemStyle(category, mention)"
            @click="selectItem(mention)"
          >
            <div v-if="category.showIcon" class="thumb">
              <img v-if="mention.mention_image" :src="mention.mention_image" />
              <svg-icon
                v-else
                :icon="mention.mention_icon"
                width="18"
                height="18"
              />
            </div>
            <div class="name">
              {{
                typeof mention.mention_name === 'function'
                  ? mention.mention_name(query)
                  : mention.mention_name
              }}
            </div>
          </div>
        </template>
      </div>
    </template>
    <div v-else class="suggestion-list__item is-empty">
      {{ notFoundText }}
    </div>
  </div>
</template>

<script>
import SvgIcon from './SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },

    command: {
      type: Function,
      required: true,
    },

    query: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      selectedMentionTypeIndex: 0,
      selectedMentionIndex: 0,
      themes: {
        default: '#354042',
        red: '#571400',
        blue: '#002e6b',
        purple: '#540093',
        cyan: '#006557',
        green: '#00500b',
        pink: '#69003f',
        gold: '#5d5a00',
        orange: '#742b00',
        lightBlue: '#005186',
        brown: '#563400',
        moss: '#386300',
      },
    };
  },

  computed: {
    hasResults() {
      return this.items.some(obj => {
        return obj.items.length > 0;
      });
    },

    selectedMentionId() {
      return this.items[this.selectedMentionTypeIndex].items[
        this.selectedMentionIndex
      ].id;
    },

    notFoundText() {
      const types = this.items.map(item => item.label.toLowerCase());
      return `No ${types.join('/')} found`;
    },
  },

  watch: {
    items(newValue, oldValue) {
      this.selectedMentionIndex = 0;
      newValue.some((type, index) => {
        if (type.items.length) {
          this.selectedMentionTypeIndex = index;
          return true;
        }
        return false;
      });
    },
  },

  methods: {
    onKeyDown({ event }) {
      if (event.key === 'ArrowUp') {
        this.upHandler();
        return true;
      }

      if (event.key === 'ArrowDown') {
        this.downHandler();
        return true;
      }

      if (event.key === 'Enter' || event.key === 'Tab') {
        event.stopImmediatePropagation();
        this.enterHandler();
        return true;
      }

      return false;
    },

    scrollToSuggestionIfNeeded(id) {
      const el = document.getElementById(`suggestion-list__item__${id}`);
      const container = this.$refs.suggestions;
      if (el.offsetTop < container.scrollTop) {
        container.scrollTop = el.offsetTop;
      } else {
        const offsetBottom = el.offsetTop + el.offsetHeight;
        const scrollBottom = container.scrollTop + container.offsetHeight;
        if (offsetBottom > scrollBottom) {
          container.scrollTop = offsetBottom - container.offsetHeight;
        }
      }
    },

    upHandler() {
      if (this.selectedMentionIndex === 0) {
        this.selectedMentionTypeIndex =
          (this.selectedMentionTypeIndex + this.items.length - 1) %
          this.items.length;
      }
      this.selectedMentionIndex =
        (this.selectedMentionIndex +
          this.items[this.selectedMentionTypeIndex].items.length -
          1) %
        this.items[this.selectedMentionTypeIndex].items.length;
      this.scrollToSuggestionIfNeeded(this.selectedMentionId);
    },

    downHandler() {
      if (
        this.selectedMentionIndex ===
        this.items[this.selectedMentionTypeIndex].items.length - 1
      ) {
        this.selectedMentionTypeIndex =
          (this.selectedMentionTypeIndex + this.items.length + 1) %
          this.items.length;
        this.selectedMentionIndex = 0;
      } else {
        this.selectedMentionIndex =
          (this.selectedMentionIndex + 1) %
          this.items[this.selectedMentionTypeIndex].items.length;
      }
      this.scrollToSuggestionIfNeeded(this.selectedMentionId);
    },

    enterHandler() {
      const item =
        this.items[this.selectedMentionTypeIndex].items[
          this.selectedMentionIndex
        ];

      this.selectItem(item);
    },

    selectItem(item) {
      console.log(item);
      if (item) {
        if (item.handler) {
          item
            .handler(item, this.query)
            .then(({ id, mention_name: mentionName }) => {
              this.command({
                id,
                type: item.mention_type,
                label: mentionName,
              });
            });
        } else {
          this.command({
            id: item.mention_id,
            type: item.mention_type,
            label:
              typeof item.mention_name === 'function'
                ? item.mention_name()
                : item.mention_name,
          });
        }
      }
    },

    itemStyle(category, item) {
      if (category.showTheme) {
        return {
          'border-left': `4px solid ${this.themes[item.mention_theme]}`,
        };
      }
      return {};
    },
  },
};
</script>

<style lang="scss" scoped></style>
